import { j as f } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as se, useRef as j, useState as G, useMemo as rn, useCallback as Zn, useLayoutEffect as fe, useEffect as wn, useImperativeHandle as or } from "react";
import { I as Ce, F as tr, i as sr } from "./focus-trap-react-CzdCUkYc.mjs";
import { l as oe } from "./lodash-5ofSKtz3.mjs";
import { P as ir } from "./popover-DAJRG9vG.mjs";
import { S as be } from "./screen-reader-only-text-B-XgpPEP.mjs";
import { _ as ar } from "./composeRefs-YONvD-rx.mjs";
import { b as Fn, k as je, f as d, h as ye, i as ve, j as Re, K as te, L as _e, M as Me, N as cr, O as ur, P as fr, l as dr, m as lr, d as Le, c as Ve, u as Oe, n as hr, o as mr, Q as gr, p as xe, q as Sn, C as ne, t as pr, x as wr, y as Cr, w as yr, s as Ee, g as ee, R as ke, z as vr, a as Mr } from "./date-picker-utils-provider-CwC1AjFc.mjs";
import { G as re } from "./grid-row-D1eZQbHo.mjs";
import { f as ln } from "./index-LyFokDcn.mjs";
import { m as de } from "./tss-DN0acMKN.mjs";
import { M as Pe, d as Be } from "./constants-CnFYFetN.mjs";
import { F as Ne } from "./flex-Cc3osQLf.mjs";
import { c as xr } from "./index-DkZ16bcJ.mjs";
import { h as Er } from "./sizes-DktS74Qp.mjs";
import { F as kr } from "./form-note-CbSVsgBQ.mjs";
import { S as Fr } from "./status-message-BMoS1d1Y.mjs";
import { L as Ir } from "./layout-box-DFBM-kSI.mjs";
import { g as Ar } from "./get-status-message-CGqgCpjJ.mjs";
import { u as br } from "./index-B1qvqCCQ.mjs";
import { g as Fe } from "./get-aria-describedby-G1wcWKF2.mjs";
function jr(n, e, r) {
  return !!(e && r && n.isValid(e) && n.isValid(r) && (n.isBefore(e, r) || n.isSameDay(e, r)));
}
const Rr = "assumedInput", Ie = 1;
function _r(n, e, r) {
  if (!n)
    throw new Error("Expected arguments are missing.");
  return e === "focusedInput" ? r : r === "end" ? "end-ish" : "start-ish";
}
function ue(n, e, r) {
  if (!n)
    throw new Error("Expected arguments are missing.");
  return {
    startValue: Fn(n, e).date,
    endValue: Fn(n, r).date
  };
}
function Lr(n, e) {
  return e ? n ? Math.min(Math.abs(n), Ie) : Ie : n && Math.abs(n);
}
function Vr(n, e, r) {
  if (e && r && n.isValid(e) && n.isValid(r)) {
    const o = n.format(e, "fullDate"), t = n.format(r, "fullDate");
    return window.jQuery ? $.__("Range updated to start at $1%s and end at $2%s", o, t) : `Range updated to start at ${o} and end at ${t}`;
  }
}
function Or({
  getDateDisabled: n,
  endDate: e,
  maxDate: r,
  minDate: o,
  startDate: t,
  utils: s
}) {
  if (!jr(s, t, e))
    return !1;
  let c = t;
  for (; s.isBefore(c, e); ) {
    if (je(s, c, o, r, n))
      return !1;
    c = s.addDays(c, 1);
  }
  return !0;
}
function Pr(n, e, r, o, t, s, c, l, M, U, L, C) {
  if (!n || !e || !d(n, e))
    throw new Error("Expected arguments are missing.");
  if (r && d(n, r) && c && d(n, c) && n.isBeforeDay(r, c) || o && d(n, o) && l && d(n, l) && n.isAfterDay(o, l) || C && d(n, r) && C(r) || C && d(n, o) && C(o))
    return !0;
  if (!r || !d(n, r) || !o || !d(n, o))
    return !1;
  if (n.isBeforeDay(o, r) || M && (te(n, r, e, M) || te(n, o, e, M)))
    return !0;
  if (!t)
    return !1;
  const R = n.addDays(r, cr);
  return n.isAfterDay(e, R) && s === "quick" ? !1 : ur(n, r, e, (y) => _e(
    n,
    y,
    r,
    o,
    c,
    l,
    C,
    U,
    L
  ));
}
function Br(n, e, r, o) {
  if (!n || !d(n, e))
    throw new Error("Expected arguments are missing.");
  return d(n, r) && d(n, o) && fr(n, e, r, o);
}
function Nr(n, e, r, o, t, s) {
  if (!n || !d(n, e))
    throw new Error("Expected arguments are missing.");
  return Dr(n, e, r, o, t, s);
}
function Dr(n, e, r, o, t, s) {
  if (!n || !e || !d(n, e))
    throw new Error("Expected arguments are missing.");
  if (o) {
    if (t && d(n, t) && n.isSameDay(e, t))
      return r === "start" || r === "start-ish";
    if (s && d(n, s) && n.isSameDay(e, s))
      return r === "end" || r === "end-ish";
  }
  return !1;
}
function $r(n, e, r, o, t, s, c) {
  if (!n || !e || !d(n, e))
    throw new Error("Expected arguments are missing.");
  return t && d(n, t) && n.isSameDay(e, t) ? !c && o ? r === "end" || r === "end-ish" : !0 : s && d(n, s) && n.isSameDay(e, s) ? !c && o ? r === "start" || r === "start-ish" : !0 : !1;
}
function Tr(n, e, r, o, t, s, c, l, M, U, L, C, R, y, w, V, I, J, _) {
  if (!n || !d(n, e))
    throw new Error("Expected arguments are missing.");
  const { startDate: B, endDate: N } = zr(
    n,
    r,
    o,
    s,
    C
  ), K = !De(
    n,
    e,
    c,
    r,
    o,
    C,
    y,
    w,
    V,
    I,
    J,
    _
  ), i = Pr(
    n,
    e,
    B,
    N,
    U,
    L,
    y,
    w,
    V,
    J,
    _,
    I
  ), m = Ur(n, e, s), O = R && m, x = !M, v = Br(n, e, B, N), Q = Nr(n, e, C, s, r, o), Y = $r(n, e, C, t, r, o, l);
  return {
    active: m,
    disabled: K,
    errored: i,
    focused: O,
    hidden: x,
    highlighted: v,
    marked: Q,
    selected: Y
  };
}
function Hr(n, e) {
  return {
    startValue: n,
    endValue: e
  };
}
function Ur(n, e, r) {
  if (!n || !e || !d(n, e))
    throw new Error("Expected arguments are missing.");
  return r ? n.isSameDay(e, r) : !1;
}
function De(n, e, r, o, t, s, c, l, M, U, L, C) {
  if (!n || !d(n, e))
    throw new Error("Expected arguments are missing.");
  if (r)
    return !1;
  if (M) {
    if (s === "start" || s === "start-ish") {
      if (te(n, t, e, M))
        return !1;
    } else if (te(n, o, e, M))
      return !1;
  }
  return !_e(
    n,
    e,
    o,
    t,
    c,
    l,
    U,
    L,
    C
  );
}
function Kr(n, e, r, o, t, s) {
  if (!n || !e)
    throw new Error("Expected arguments are missing.");
  return r || d(n, o) && ye(n, e, o) || d(n, t) && !!s && ye(n, e, t);
}
function Wr(n, e, r, o, t, s) {
  if (!n || !e)
    throw new Error("Expected arguments are missing.");
  return r || d(n, o) && ve(n, e, o) || d(n, t) && !!s && ve(n, e, t);
}
function zr(n, e, r, o, t) {
  if (!n)
    throw new Error("Expected arguments are missing.");
  return o ? $e(n, o, e, r, t) : {
    startDate: e,
    endDate: r
  };
}
function $e(n, e, r, o, t) {
  if (!n)
    throw new Error("Expected arguments are missing.");
  return t === "end" ? {
    startDate: r,
    endDate: e
  } : t === "start" ? {
    startDate: e,
    endDate: o
  } : t === "end-ish" ? Me(n, r, e) : Me(n, e, o);
}
function Ae(n, e, r, o) {
  if (!n)
    throw new Error("Expected arguments are missing.");
  const t = !!e && d(n, e), s = !!r && d(n, r);
  return t && s && n.isSameDay(n.startOfMonth(e), n.startOfMonth(r)) ? n.startOfMonth(e) : (o === "end" || o === "end-ish") && s ? n.startOfMonth(n.getPreviousMonth(r)) : t ? n.startOfMonth(e) : s ? n.startOfMonth(n.getPreviousMonth(r)) : n.startOfMonth(Re(n));
}
function Gr(n, e, r, o) {
  const t = Re(n), s = o === "start" || o === "start-ish", c = o === "end" || o === "end-ish";
  return e && !n.isValid(e) && (e = void 0), r && !n.isValid(r) && (r = void 0), s ? e || r || t : c && (r || e) || t;
}
const Qr = de()((n, e) => {
  const { borderRadiuses: r, constructs: o, mixins: t, mode: s, palette: c, spacing: l } = n, { maxWeekRowsCount: M } = e;
  return {
    calendars: {
      display: "flex",
      justifyContent: ln.ifFeature("encore", "space-evenly"),
      width: "100%"
    },
    endPicker: {
      // @startCleanup encore
      borderLeft: ln.ifFeature("encore", void 0, t.border(1, c.grey[400])),
      // @endCleanup encore
      "& .PrivatePickersFadeTransitionGroup-root": {
        "&>div>div>div:first-of-type": {
          borderLeft: ln.ifFeature("encore", t.border(1, o.border.neutral.xWeak))
        }
      },
      "& .PrivatePickersSlideTransition-root": {
        "&>div:first-of-type": {
          borderLeft: ln.ifFeature("encore", t.border(1, o.border.neutral.xWeak))
        }
      }
    },
    hidden: {
      visibility: "hidden"
    },
    picker: {
      backgroundColor: c.grey[100],
      borderRadius: ln.ifFeature("encore", r[200]),
      margin: ln.ifFeature("encore", l(0.5)),
      overflow: "hidden",
      position: "relative",
      "& .MuiPickersBasePicker-pickerView": {
        minHeight: 0,
        padding: 0
      },
      "& .MuiPickersCalendar-transitionContainer": {
        backgroundColor: c.common.white,
        marginTop: 10,
        minHeight: 12 + M * 32,
        transition: "min-height 100ms"
      },
      "& .MuiPickersCalendar-transitionContainer > div": {
        top: 8
      },
      "& .MuiPickersCalendarHeader-transitionContainer": {
        display: "none"
      },
      width: ln.ifFeature("encore", 633, 616)
    },
    root: {
      backgroundColor: s === Pe.Dye ? Be.main : void 0,
      display: "flex",
      width: ln.ifFeature("encore", 633, 616)
    },
    startPicker: {}
  };
});
function Yr(n, e, r, o, t = {}, s = e) {
  const c = dr(
    n,
    e,
    n.startOfDay(n.endOfMonth(r)),
    t
  );
  if (!je(n, s, c.minDate, c.maxDate, c.getDateDisabled))
    return s;
  const { next: l, previous: M } = lr(n, s, c);
  if (o === "start" || o === "start-ish")
    return l || M;
  if (o === "end" || o === "end-ish")
    return M || l;
}
function Jr(n, {
  endDate: e,
  maxRangeSpanYears: r,
  maxDate: o,
  startDate: t,
  targetSelectionType: s
} = {}) {
  if (o = d(n, o) ? o : Le(n), s === "start" && e && d(n, e) && n.isBefore(e, o))
    return e;
  const c = s === "start" || s === "start-ish" ? e : t;
  if (r && c && d(n, c)) {
    const l = n.addMonths(c, 12 * r);
    if (n.isBefore(l, o))
      return l;
  }
  return o;
}
function Xr(n, {
  endDate: e,
  maxRangeSpanYears: r,
  minDate: o,
  startDate: t,
  targetSelectionType: s
} = {}) {
  if (o = d(n, o) ? o : Ve(n), s === "end" && t && d(n, t) && n.isAfter(t, o))
    return t;
  const c = s === "start" || s === "start-ish" ? e : t;
  if (r && c && d(n, c)) {
    const l = n.addMonths(c, -12 * r);
    if (n.isAfter(l, o))
      return l;
  }
  return o;
}
function qr({
  autofocus: n = !1,
  className: e,
  classes: r = {},
  disabled: o = !1,
  endDate: t,
  getDateDisabled: s,
  maxDate: c,
  maxRangeSpanYears: l,
  minDate: M,
  onChange: U,
  onMenuClose: L,
  onMenuOpen: C,
  renderDate: R,
  startDate: y,
  targetSelectionType: w,
  validateDisabledDatesWithinRange: V = !1
}, I) {
  const J = j(!1), _ = j(y), B = j(t), N = j(), K = j(null), i = Oe(), [m, O] = G(() => Ae(i, y, t, w)), x = rn(
    () => Jr(i, {
      endDate: t,
      maxDate: c,
      maxRangeSpanYears: l,
      startDate: y,
      targetSelectionType: w
    }),
    [t, c, l, y, w, i]
  ), v = rn(
    () => Xr(i, {
      endDate: t,
      maxRangeSpanYears: l,
      minDate: M,
      startDate: y,
      targetSelectionType: w
    }),
    [t, l, M, y, w, i]
  ), Q = d(i, y) && w === "end", Y = d(i, t) && w === "start", X = Zn(
    (a, h) => Yr(
      i,
      a,
      i.getNextMonth(a),
      w,
      {
        getDateDisabled: s,
        maxDate: x,
        minDate: v
      },
      h
    ),
    // We don't want to put the getDateDisabled prop in the dependency array
    // to avoid possible infinite render loops
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [x, v, w, i]
  ), hn = Zn(() => {
    const a = Gr(i, y, t, w);
    return X(m, a);
  }, [t, X, y, w, i, m]);
  function Cn() {
    var p;
    if (!K.current)
      return;
    const a = pr(K.current);
    if (oe.findLast(a, (D) => D.hasAttribute("data-calendar-day"))) {
      W(!0);
      return;
    }
    (p = a[0]) == null || p.focus();
  }
  const [E, Tn] = G(hn), [on, yn] = G(E), [In, tn] = G(!1), [An, sn] = G("full"), [q, W] = G(n), k = i.getNextMonth(m), Z = i.getWeekArray(m).length, an = i.getWeekArray(k).length, cn = {
    maxWeekRowsCount: Math.max(Z, an)
  }, { classes: S, cx: vn } = Qr(cn);
  fe(() => {
    O(Ae(i, y, t, w));
  }, [w]), wn(() => {
    n && Cn();
  }, [n]);
  const un = hr(i, v, x), bn = Kr(
    i,
    m,
    o,
    v,
    y,
    Q
  ), jn = Wr(
    i,
    k,
    o,
    x,
    t,
    Y
  ), A = mr(i), Mn = i.getYear(m), Rn = i.getMonth(m) + 1, _n = i.getYear(k), zn = i.getMonth(k) + 1, Ln = Zn(
    (a, h) => {
      const { date: p } = h;
      V && (N.current && (clearTimeout(N.current), N.current = void 0), N.current = setTimeout(() => {
        J.current || (sn("full"), N.current = void 0);
      }, gr), sn("quick")), yn(p), tn(!1);
    },
    [V]
  ), nn = Zn(() => {
    yn(E);
  }, [E]);
  fe(() => () => {
    J.current = !0;
  }, []);
  function P(a) {
    yn(a), Tn(a);
  }
  function mn(a, h, p) {
    if (!(h === "finish" || h === !0) || !De(
      i,
      a,
      o,
      _.current,
      B.current,
      w,
      v,
      x,
      l,
      s,
      Q,
      Y
    ))
      return;
    const { startDate: gn, endDate: Pn } = $e(
      i,
      a,
      _.current,
      B.current,
      w
    ), Kn = Hr(gn, Pn);
    U(Kn), tn(oe.isBoolean(p) ? p : !0);
  }
  function Vn() {
    _.current = y, B.current = t;
  }
  function fn(a) {
    if (a.key === " " || a.key === "Enter") {
      E && (a.preventDefault(), Vn(), mn(E, !0));
      return;
    }
    if (wr(a)) {
      a.preventDefault();
      const h = Cr({
        activeDate: on,
        getDateDisabled: s,
        keyboardKey: a.key,
        maxDate: x,
        minDate: v,
        shiftKeyPressed: a.shiftKey,
        utils: i
      });
      !i.isSameMonth(h, m) && !i.isSameMonth(h, k) && (i.isBefore(h, m) ? O(i.startOfMonth(h)) : O(i.startOfMonth(i.addMonths(h, -1)))), P(h), tn(!1);
    }
  }
  function ie({ currentTarget: a }) {
    a.contains(document.activeElement) || Cn();
  }
  const en = (a) => {
    const h = X(a, E);
    P(h), O(a);
  };
  function On(a, h, p) {
    if (R) {
      const Dn = Fn(i, a), $n = Fn(i, y), Wn = Fn(i, t);
      return R(Dn, $n, Wn, h);
    }
    const { outsideCurrentMonth: D } = h, gn = Tr(
      i,
      a,
      y,
      t,
      E,
      on,
      o,
      In,
      !D,
      V,
      An,
      w,
      q,
      v,
      x,
      l,
      s,
      Q,
      Y
    ), { active: Pn, errored: Kn, marked: ae, disabled: T, selected: H, focused: Bn, highlighted: Nn } = gn;
    return /* @__PURE__ */ f.jsx(
      yr,
      {
        ...h,
        active: Pn,
        day: a,
        disabled: T,
        errored: Kn,
        focused: E && i.isSameMonth(E, p) ? Bn : !1,
        inRange: Nn,
        marked: ae,
        onMouseEnter: Ln,
        onMouseLeave: nn,
        selected: H
      }
    );
  }
  function Hn({ month: a, year: h }) {
    const p = Ee(i, h, a), D = X(p, E);
    P(D), O(p);
  }
  function Gn({ month: a, year: h }) {
    const p = Ee(i, h, a), D = i.getPreviousMonth(p), gn = X(D, E);
    P(gn), O(D);
  }
  function xn(a) {
    if (a === "next-month") {
      en(i.addMonths(m, 1));
      return;
    }
    en(i.addMonths(m, -1));
  }
  wn(() => {
    P(hn());
  }, [y, t, w, hn]);
  const Qn = xe(i, m), Un = xe(i, k), g = Math.max(Qn, Un);
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        className: vn(S.root, S.picker, e, r.root),
        onClick: ie,
        onMouseDown: Vn,
        ref: ar(I, K),
        children: [
          ln.ifFeature(
            "encore",
            /* @__PURE__ */ f.jsxs("div", { children: [
              /* @__PURE__ */ f.jsxs(Ne, { justifyContent: "space-evenly", marginTop: 1, marginX: 3.4, children: [
                /* @__PURE__ */ f.jsx(
                  Sn,
                  {
                    disabled: o,
                    hideRightArrow: !0,
                    leftArrowDisabled: bn,
                    maxDate: x,
                    minDate: v,
                    months: A,
                    monthValue: Rn,
                    onArrowClick: xn,
                    onChange: Hn,
                    onMenuClose: L,
                    onMenuOpen: C,
                    years: un,
                    yearValue: Mn
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  Sn,
                  {
                    disabled: o,
                    hideLeftArrow: !0,
                    maxDate: x,
                    minDate: v,
                    months: A,
                    monthValue: zn,
                    onArrowClick: xn,
                    onChange: Gn,
                    onMenuClose: L,
                    onMenuOpen: C,
                    rightArrowDisabled: jn,
                    years: un,
                    yearValue: _n
                  }
                )
              ] }),
              /* @__PURE__ */ f.jsxs(
                "div",
                {
                  className: S.calendars,
                  onBlur: () => W(!1),
                  onFocus: () => W(!0),
                  onKeyDown: fn,
                  children: [
                    /* @__PURE__ */ f.jsx(
                      ne,
                      {
                        date: m || null,
                        maxDate: x,
                        minDate: v,
                        onChange: mn,
                        renderDay: (a, h, p) => On(a, p, m),
                        weeksToShow: g
                      }
                    ),
                    /* @__PURE__ */ f.jsx("div", { className: vn(S.endPicker), children: /* @__PURE__ */ f.jsx(
                      ne,
                      {
                        date: k || null,
                        maxDate: x,
                        minDate: v,
                        onChange: mn,
                        renderDay: (a, h, p) => On(a, p, k),
                        weeksToShow: g
                      }
                    ) })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ f.jsxs(re, { container: !0, margin: "none", spacing: 0, children: [
              /* @__PURE__ */ f.jsxs(re, { margin: "none", children: [
                /* @__PURE__ */ f.jsx(re, { margin: "none", marginTop: 1, marginX: 1, children: /* @__PURE__ */ f.jsx(
                  Sn,
                  {
                    disabled: o,
                    hideRightArrow: !0,
                    leftArrowDisabled: bn,
                    maxDate: x,
                    minDate: v,
                    months: A,
                    monthValue: Rn,
                    onArrowClick: xn,
                    onChange: Hn,
                    onMenuClose: L,
                    onMenuOpen: C,
                    years: un,
                    yearValue: Mn
                  }
                ) }),
                /* @__PURE__ */ f.jsx(re, { justifyContent: "end", margin: "none", children: /* @__PURE__ */ f.jsx(
                  Sn,
                  {
                    disabled: o,
                    hideLeftArrow: !0,
                    maxDate: x,
                    minDate: v,
                    months: A,
                    monthValue: zn,
                    onArrowClick: xn,
                    onChange: Gn,
                    onMenuClose: L,
                    onMenuOpen: C,
                    rightArrowDisabled: jn,
                    years: un,
                    yearValue: _n
                  }
                ) })
              ] }),
              /* @__PURE__ */ f.jsxs(
                "div",
                {
                  className: S.calendars,
                  onBlur: () => W(!1),
                  onFocus: () => W(!0),
                  onKeyDown: fn,
                  children: [
                    /* @__PURE__ */ f.jsx(
                      ne,
                      {
                        date: m || null,
                        maxDate: x,
                        minDate: v,
                        onChange: mn,
                        renderDay: (a, h, p) => On(a, p, m),
                        weeksToShow: g
                      }
                    ),
                    /* @__PURE__ */ f.jsx("div", { className: vn(S.endPicker), children: /* @__PURE__ */ f.jsx(
                      ne,
                      {
                        date: k || null,
                        maxDate: x,
                        minDate: v,
                        onChange: mn,
                        renderDay: (a, h, p) => On(a, p, k),
                        weeksToShow: g
                      }
                    ) })
                  ]
                }
              )
            ] })
          ),
          /* @__PURE__ */ f.jsx(be, { ariaAtomic: !0, ariaLive: "polite", children: window.jQuery ? $.__(
            "Showing %1$s and %2$s",
            i.format(m, "monthAndYear"),
            i.format(k, "monthAndYear")
          ) : `Showing ${i.format(m, "monthAndYear")} and ${i.format(
            k,
            "monthAndYear"
          )}` })
        ]
      }
    )
  );
}
const Zr = se(qr), Sr = window.jQuery ? $.__("To") : "To", no = window.jQuery ? $.__("From") : "From";
function eo(n, e) {
  const { inputValue: r, value: o } = e;
  return {
    inputValue: r,
    type: n,
    value: o
  };
}
function ro(n, e) {
  return n === "error" || e === "error" ? "error" : n === "warning" || e === "warning" ? "warning" : n === "info" || e === "info" ? "info" : "default";
}
const oo = de()(({ palette: n }, { size: e, disabled: r }) => ({
  endDate: {},
  rangeSeparator: {
    alignItems: "center",
    display: "flex",
    // The default size is set to medium
    // outlineInputHeight is the height of the input field on both sides of the range separator
    // we set the height equal to those so the separator is vertically centered
    height: Er[e || "medium"],
    margin: "0 8px"
  },
  root: {
    alignItems: "flex-end",
    color: r ? n.gray[600] : n.gray[1e3],
    display: "flex",
    flexWrap: "nowrap"
  },
  startDate: {}
})), to = se(
  ({
    biId: n,
    className: e,
    classes: r = {},
    disabled: o = !1,
    calendarId: t,
    endAfterLabel: s,
    endAriaDescribedby: c,
    endBiId: l,
    endCalendarButtonRef: M,
    endDisabled: U,
    endInputProps: L = {},
    endLabel: C = Sr,
    endPopupToggleButtonProps: R,
    endRequired: y,
    endStatus: w = "default",
    endValue: V,
    id: I,
    isPopoverOpen: J,
    note: _,
    notePlacement: B,
    onBlur: N,
    onChange: K,
    onPopupToggle: i,
    required: m = !1,
    size: O = "medium",
    startAfterLabel: x,
    startAriaDescribedby: v,
    startBiId: Q,
    startDisabled: Y,
    startCalendarButtonRef: X,
    startInputProps: hn = {},
    startLabel: Cn = no,
    startPopupToggleButtonProps: E,
    startRequired: Tn,
    startStatus: on = "default",
    startValue: yn,
    viewMode: In = !1,
    variant: tn,
    width: An
  }, sn) => {
    Y && U && (o = !0);
    const q = {
      disabled: o,
      size: O
    }, { classes: W } = oo(q), k = ro(on, w), Z = /* @__PURE__ */ f.jsxs("div", { className: xr(W.root, e, r.root), ref: sn, children: [
      /* @__PURE__ */ f.jsx("div", { className: W.startDate, children: /* @__PURE__ */ f.jsx(
        Ce,
        {
          afterLabel: x,
          ariaDescribedby: v,
          biId: n ? `${n}_start-input-date` : Q,
          calendarButtonRef: X,
          calendarId: t,
          disabled: o || Y,
          id: I && `${I}-start-date`,
          inputProps: hn,
          isPopoverOpen: J,
          label: Cn,
          onBlur: an,
          onChange: bn,
          onPopupToggle: jn,
          popupToggleButtonProps: E,
          required: Tn || m,
          size: O,
          status: on,
          value: yn,
          variant: tn,
          viewMode: In,
          width: An
        }
      ) }),
      /* @__PURE__ */ f.jsx("div", { className: W.rangeSeparator, children: "–" }),
      /* @__PURE__ */ f.jsx("div", { className: W.endDate, children: /* @__PURE__ */ f.jsx(
        Ce,
        {
          afterLabel: s,
          ariaDescribedby: c,
          biId: n ? `${n}_end-input-date` : l,
          calendarButtonRef: M,
          calendarId: t,
          disabled: o || U,
          id: I && `${I}-end-date`,
          inputProps: L,
          isPopoverOpen: J,
          label: C,
          note: B !== "block" && _,
          noteStatus: k,
          onBlur: an,
          onChange: S,
          onPopupToggle: vn,
          popupToggleButtonProps: R,
          required: y || m,
          size: O,
          status: w,
          value: V,
          variant: tn,
          viewMode: In,
          width: An
        }
      ) })
    ] });
    return B === "block" && tn !== "single" ? /* @__PURE__ */ f.jsxs(Ne, { flexDirection: "column", gap: 1, children: [
      Z,
      /* @__PURE__ */ f.jsx(kr, { status: k === "default" ? void 0 : k, children: _ })
    ] }) : Z;
    function an(A) {
      typeof N == "function" && N(A);
    }
    function cn(A, Mn) {
      const Rn = eo(A, Mn);
      K(Rn);
    }
    function S(A) {
      cn("end", A);
    }
    function vn() {
      un("end");
    }
    function un(A) {
      i && i(A);
    }
    function bn(A) {
      cn("start", A);
    }
    function jn() {
      un("start");
    }
  }
), so = de()(({ mode: n }) => ({
  popoverArrow: {
    transition: "transform 0.5s"
  },
  root: {
    outline: n === Pe.Dye ? `1px solid ${Be.main}` : void 0
  }
}));
function io(n, e) {
  if (n === "error" || e === "error")
    return "error";
  if (n === "warning" || e === "warning")
    return "warning";
  if (n === "info" || e === "info")
    return "info";
}
function ao(n, e, r, o) {
  const t = rn(() => oe.uniqueId("fabric-date-picker-range-status-message"), []), s = io(n, e), c = Ar(s, r, o);
  return (s === "error" || s === "warning") && c ? {
    id: t,
    message: c,
    status: s
  } : void 0;
}
const co = se(function({
  apiRef: e,
  biId: r,
  calendarSelectionMode: o = Rr,
  classes: t = {},
  className: s,
  DatePickerCalendarRangeProps: c = {},
  disabled: l,
  endAfterLabel: M,
  endAriaDescribedby: U,
  endBiId: L,
  endDisabled: C,
  endInputProps: R = {},
  endLabel: y,
  endRequired: w,
  endStatus: V,
  endValue: I,
  errorMessage: J,
  getDateDisabled: _,
  id: B,
  InputDateRangeProps: N = {},
  maxDate: K,
  maxRangeSpanYears: i,
  minDate: m,
  note: O,
  notePlacement: x,
  onBlur: v,
  onChange: Q,
  onClose: Y,
  onError: X,
  onOpen: hn,
  onPopupToggle: Cn,
  open: E,
  renderDate: Tn,
  required: on = !1,
  size: yn = "medium",
  startAfterLabel: In,
  startAriaDescribedby: tn,
  startBiId: An,
  startDisabled: sn,
  startInputProps: q = {},
  startLabel: W,
  startRequired: k,
  startStatus: Z,
  startValue: an,
  validateDisabledDatesWithinRange: cn = !1,
  variant: S = "form",
  viewMode: vn,
  warningMessage: un,
  width: bn,
  ...jn
}, A) {
  const Mn = j(!1), Rn = j(null), _n = j(null), zn = j(null), Ln = j(null), nn = j(""), P = j(""), mn = j(void 0), Vn = j(!0), [fn, ie] = G(), en = j(null);
  fe(() => () => {
    Mn.current = !0;
  }, []);
  const [On, Hn] = G(!1), Gn = {
    shouldTransitionArrow: E || On
  }, { cx: xn, classes: Qn } = so(), { palette: Un } = br(), g = Oe(), [a, h] = G(!1), [p, D] = G("start"), [gn, Pn] = G(!1), [Kn, ae] = G(Un.gray[100]), T = rn(() => ee(g, an), [g, an]), H = rn(() => ee(g, I), [g, I]), Bn = rn(() => ee(g, m), [g, m]), Nn = rn(() => Bn || Ve(g), [g, Bn]), Dn = rn(() => ee(g, K), [g, K]), $n = rn(() => Dn || Le(g), [g, Dn]), Wn = Lr(i, cn);
  wn(() => {
    an && !T && console.warn("The provided 'DatePickerRange' component's 'startValue' prop is being ignored because it is invalid.");
  }, [T, an]), wn(() => {
    I && !H && console.warn("The provided 'DatePickerRange' component's 'endValue' prop is being ignored because it is invalid.");
  }, [H, I]), wn(() => {
    m && !Bn && console.warn("The provided 'DatePickerRange' component's 'minDate' prop is being ignored because it is invalid.");
  }, [m, Bn]), wn(() => {
    K && !Dn && console.warn("The provided 'DatePickerRange' component's 'maxDate' prop is being ignored because it is invalid.");
  }, [K, Dn]);
  const En = R.ref || Rn, kn = q.ref || zn;
  C && sn && (l = !0), o = sn || C ? "focusedInput" : o, wn(() => {
    return window.addEventListener("click", u), () => {
      window.removeEventListener("click", u);
    };
    function u(z) {
      const F = z.target;
      Ln.current && Ln.current.contains(F) || _n.current && _n.current.contains(F) || qn();
    }
  }), wn(() => {
    if (Vn.current) {
      Vn.current = !1;
      return;
    }
    Yn(T, H, nn.current, P.current);
  }, [
    g,
    T,
    H,
    on,
    Nn,
    $n,
    Wn,
    cn,
    _,
    nn.current,
    P.current
  ]), or(
    e,
    () => ({
      focusStart: () => {
        var u;
        return (u = kn.current) == null ? void 0 : u.focus();
      },
      focusEnd: () => {
        var u;
        return (u = En.current) == null ? void 0 : u.focus();
      }
    }),
    []
  );
  const le = E || a, he = j();
  he.current = p;
  let me = 0;
  En != null && En.current && (kn != null && kn.current) && p === "end" && (me = Math.round(En.current.getBoundingClientRect().x - kn.current.getBoundingClientRect().x));
  const ge = rn(() => typeof B == "string" ? B.replaceAll(" ", "-") : oe.uniqueId(), []), pn = ao(Z, V, J, un);
  return /* @__PURE__ */ f.jsxs("div", { className: xn(s, t.root, Qn.root), "data-fabric-component": jn["data-fabric-component"], ref: A, children: [
    /* @__PURE__ */ f.jsx(
      to,
      {
        ...N,
        biId: r && `${r}_date-picker-range_input-date-range`,
        calendarId: ge,
        disabled: l,
        endAfterLabel: M,
        endAriaDescribedby: Fe(
          V === "error" || V === "warning" ? pn == null ? void 0 : pn.id : "",
          U,
          R["aria-describedby"]
        ),
        endBiId: L,
        endCalendarButtonRef: en,
        endDisabled: C,
        endInputProps: {
          ...R,
          "aria-invalid": V === "error" || R["aria-invalid"],
          ref: En,
          onFocus: We
        },
        endLabel: y,
        endRequired: w,
        endStatus: V,
        endValue: H,
        id: B,
        isPopoverOpen: a,
        note: O,
        notePlacement: x,
        onBlur: Ge,
        onChange: Qe,
        onPopupToggle: qe,
        ref: _n,
        required: on,
        size: yn,
        startAfterLabel: In,
        startAriaDescribedby: Fe(
          Z === "error" || Z === "warning" ? pn == null ? void 0 : pn.id : "",
          tn,
          q["aria-describedby"]
        ),
        startBiId: An,
        startCalendarButtonRef: ie,
        startDisabled: sn,
        startInputProps: {
          ...q,
          "aria-live": "assertive",
          "aria-invalid": Z === "error" || q["aria-invalid"],
          ref: kn,
          onFocus: Se
        },
        startLabel: W,
        startRequired: k,
        startStatus: Z,
        startValue: T,
        variant: S,
        viewMode: vn,
        width: bn
      }
    ),
    fn && /* @__PURE__ */ f.jsx(
      ir,
      {
        anchorEl: fn,
        arrowFill: Kn,
        autofocus: !1,
        classes: { arrow: xn({ [Qn.popoverArrow]: Gn.shouldTransitionArrow }) },
        disableOuterClickOnClose: !0,
        hasCloseButton: !1,
        hasMaxWidth: !1,
        id: `date-picker-control-${ge}`,
        isRounded: !0,
        modifiers: [
          {
            name: "arrow",
            enabled: !0,
            fn: ({ state: u }) => {
              u.modifiersData.arrow.x = me + 4;
            }
          }
        ],
        noPadding: !0,
        onFlip: (u) => Ze(u),
        open: E === void 0 ? a : E,
        placement: "bottom-start",
        ref: Ln,
        variant: "bordered",
        children: /* @__PURE__ */ f.jsx(
          tr,
          {
            active: le,
            focusTrapOptions: {
              clickOutsideDeactivates: !0,
              delayInitialFocus: !0,
              escapeDeactivates: !1,
              initialFocus: !1,
              setReturnFocus: () => {
                const u = he.current;
                return u === "end" && en.current ? en.current : u === "start" && fn ? fn : !1;
              },
              tabbableOptions: { displayCheck: "none" }
            },
            paused: gn,
            children: /* @__PURE__ */ f.jsx("div", { onKeyDown: ze, children: /* @__PURE__ */ f.jsx(
              Zr,
              {
                ...c,
                autofocus: le,
                disabled: l,
                endDate: H,
                getDateDisabled: pe,
                maxDate: $n,
                maxRangeSpanYears: Wn,
                minDate: Nn,
                onChange: Ue,
                onMenuClose: Ye,
                onMenuOpen: Je,
                renderDate: Tn,
                startDate: T,
                targetSelectionType: _r(g, o, p),
                validateDisabledDatesWithinRange: cn
              }
            ) })
          }
        )
      }
    ),
    pn && /* @__PURE__ */ f.jsx(Ir, { marginTop: 1, children: /* @__PURE__ */ f.jsx(Fr, { ...pn }) }),
    /* @__PURE__ */ f.jsx(be, { ariaAtomic: !0, ariaLive: "polite", children: Vr(g, T, H) })
  ] });
  function Te(u) {
    u === "end" ? Jn() : Xn();
  }
  function He(u, z) {
    ke(g, u, z) === "onlyStart" ? Jn() : Xn();
  }
  function Ue(u) {
    const z = ke(g, u.startValue, u.endValue);
    let { startValue: F, endValue: b } = u;
    const dn = Or({
      endDate: b,
      getDateDisabled: (rr) => typeof _ == "function" ? _(Fn(g, rr)) : !1,
      maxDate: $n,
      minDate: Nn,
      startDate: F,
      utils: g
    });
    z === "complete" && dn ? qn() : dn ? He(F, b) : p === "start" ? (b = void 0, Jn()) : (F = void 0, Xn());
    const ce = nn.current, er = P.current;
    F !== T && (nn.current = F === H ? er : ""), b !== H && (P.current = b === T ? ce : ""), Q(ue(g, F, b)), Yn(F, b, nn.current, P.current);
  }
  function Ke() {
    h(!1), Hn(!1), Y && Y();
  }
  function We(u) {
    we("end"), R.onFocus && R.onFocus(u);
  }
  function Yn(u, z, F, b) {
    if (X) {
      if (Vn.current)
        return;
      const dn = vr(
        g,
        u,
        z,
        F,
        b,
        on,
        k || !1,
        w || !1,
        cn,
        Nn,
        $n,
        Wn,
        pe
      );
      dn && JSON.stringify(dn) !== JSON.stringify(mn.current) && (mn.current = dn, X(dn));
    }
  }
  function ze(u) {
    u.key === "Escape" && !gn && (u.preventDefault(), qn());
  }
  function pe(u) {
    return _ ? _(Fn(g, u)) : !1;
  }
  function Ge(u) {
    const z = kn.current, F = En.current, b = Ln.current, dn = [F, z, b].filter((ce) => !!ce);
    typeof v == "function" && !sr(dn, u) && v();
  }
  function Qe(u) {
    const { inputValue: z, type: F, value: b } = u;
    F === "start" ? (nn.current = z, Q(ue(g, b, H)), Yn(b, H, nn.current, P.current)) : (P.current = z, Q(ue(g, T, b)), Yn(T, b, nn.current, P.current));
  }
  function we(u) {
    D(u);
  }
  function Ye() {
    Pn(!1);
  }
  function Je() {
    Pn(!0);
  }
  function Xe() {
    h(!0), hn && hn(), setTimeout(() => {
      Mn.current || Hn(!0);
    }, 0);
  }
  function qe(u) {
    Te(u), a ? u === p && qn() : nr(), Cn && Cn(u);
  }
  function Ze(u) {
    ae(u.includes("bottom") ? Un.gray[100] : Un.common.white);
  }
  function Se(u) {
    we("start"), q.onFocus && q.onFocus(u);
  }
  function Jn() {
    if (!l) {
      if (C) {
        Xn();
        return;
      }
      en != null && en.current && en.current.focus(), D("end");
    }
  }
  function Xn() {
    if (!l) {
      if (sn) {
        Jn();
        return;
      }
      fn && fn.focus(), D("start");
    }
  }
  function qn() {
    E === void 0 && a && Ke();
  }
  function nr() {
    E === void 0 && (a || Xe());
  }
}), _o = se(function(e, r) {
  return /* @__PURE__ */ f.jsx(Mr, { children: /* @__PURE__ */ f.jsx(co, { ...e, "data-fabric-component": "DatePickerRange", ref: r }) });
});
export {
  _o as D,
  Lr as g
};
//# sourceMappingURL=date-picker-range-1KaSlHL8.mjs.map
